import { render, staticRenderFns } from "./about-ob.vue?vue&type=template&id=3eb3fbcc&scoped=true"
import script from "./about-ob.vue?vue&type=script&lang=js"
export * from "./about-ob.vue?vue&type=script&lang=js"
import style0 from "./about-ob.vue?vue&type=style&index=0&id=3eb3fbcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb3fbcc",
  null
  
)

export default component.exports